import React, { useState, useMemo } from 'react'
import {useSubscription } from '@apollo/client';
import { useSyncedStore } from '@syncedstore/react';

import Container from 'src/components/shared/container';
import {PARCEL_WORKER_TASK } from 'src/graphql/subscription/parcel.subscription';
import { useSelectDate } from 'src/hooks/useSelectDate';
import { useParcelStore } from 'src/store/parcel';
import { todoStore } from 'src/store/todo';

import { WorkerTaskingLive } from '../worker-tasking-live';

type Props={
    workerId:string
}

const WorkerDetails: React.FC<Props> = ({workerId}) => {

    const [startDate, setStartDate] = useState('')
    const [endDate, setEndDate] = useState('')
    const activeParcel= useParcelStore((state)=>state.parcel)
    const state = useSyncedStore(todoStore)

    useSelectDate({ setStartDate, setEndDate });

    const { data, loading, } = useSubscription(PARCEL_WORKER_TASK,
        {variables:{
            id:activeParcel,
            worker_id:workerId,
            task_start_date: startDate,
            task_end_date: endDate

       },
       skip:!activeParcel
    });
    const record = data?.parcels_by_pk

    // Filter zones and locations based on worker assignments
    const filteredZones = useMemo(() => {
        if (!record?.zones || !state.workerAssignments) return record?.zones;

        // Get active assignments for this worker
        const workerAssignments = state.workerAssignments.filter(
            (assignment) => assignment.workerId === workerId && !assignment.softDeleted
        );

        if (workerAssignments.length === 0) return record.zones;

        // Filter zones to only include those with assignments
        return record.zones.map((zone: Record<string, unknown>) => {
            // Find assignments for this zone
            const zoneAssignments = workerAssignments.filter(
                (assignment) => assignment.zoneId === zone.id
            );

            if (zoneAssignments.length === 0) return null;

            // Check if any assignment has a specific locationId
            const locationSpecificAssignments = zoneAssignments.filter(
                (assignment) => assignment.locationId
            );

            // If there are location-specific assignments, filter locations
            if (locationSpecificAssignments.length > 0) {
                const assignedLocationIds = locationSpecificAssignments.map(
                    (assignment) => assignment.locationId
                );

                const locationsAggregate = zone.locations_aggregate as Record<string, unknown> | undefined;
                const nodes = locationsAggregate?.nodes as Record<string, unknown>[] | undefined;

                return {
                    ...zone,
                    locations_aggregate: {
                        ...(locationsAggregate || {}),
                        nodes: nodes
                            ? nodes.filter((location: Record<string, unknown>) =>
                                assignedLocationIds.includes(location.id as string)
                            )
                            : []
                    }
                };
            }

            // Otherwise, return the zone with all its locations
            return zone;
        }).filter(Boolean); // Remove null zones
    }, [record?.zones, state.workerAssignments, workerId]);

    return (
        <Container>
            <div>
            <h1 className='text-xl font-medium'>Tasks</h1>
            </div>
            <WorkerTaskingLive
            activeParcel={activeParcel}
            zones={filteredZones}
            locationDensity={record?.widget_parcel_location_density}
            loading={loading}/>
        </Container>
    )
}

export default WorkerDetails
